const FUNCTIONS = {
    MULTI_THEMES: 'horizon.multi_themes',
    EXCEL_RTD: 'horizon.excel_rtd'
};

export default FUNCTIONS;
